const factorSidebarGroups = [
  {
    label: 'Expected Returns (Ann.)',
    attributes: ['Exp5YRReturn']
  },
  {
    label: 'Expected Risk (Ann.)',
    attributes: ['Exp5YRVol', 'Exp5YRSharpe']
  },
  {
    label: 'Valuations (Long vs. Short)',
    attributes: ['CurrentRelValAgg', 'RelValAgg50th']
  },
  {
    label: 'Historical Returns (Ann.)',
    attributes: ['HistITDReturn', 'HistITDRevalAlpha', 'HistITDStructAlpha']
  }
]

export function getSidebarGroups() {
  return factorSidebarGroups
}



// WEBPACK FOOTER //
// ./src/components/factors/aggregate/sidebar-groups.js